import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=4e53f9a1&"
import script from "./ServiceTable.vue?vue&type=script&lang=js&"
export * from "./ServiceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports